/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import n from "./has.js";
var e = new Set();

function i(n, i) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  o && e.has(i) || (o && e.add(i), n.warn("\uD83D\uDED1 DEPRECATED - ".concat(i)));
}

function o(e, i) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  n("esri-deprecation-warnings") && s(e, "Module: ".concat(i), o);
}

function t(e, i) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (n("esri-deprecation-warnings")) {
    var _n = o.moduleName;
    s(e, "Function: ".concat((_n ? _n + "::" : "") + i + "()"), o);
  }
}

function r(e, i) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (n("esri-deprecation-warnings")) {
    var _n2 = o.moduleName;
    s(e, "Property: ".concat((_n2 ? _n2 + "::" : "") + i), o);
  }
}

function s(e, o) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (n("esri-deprecation-warnings")) {
    var _n3 = t.replacement,
        _r = t.version,
        _s = t.see,
        a = t.warnOnce;
    var c = o;
    _n3 && (c += "\n\t\uD83D\uDEE0\uFE0F Replacement: ".concat(_n3)), _r && (c += "\n\t\u2699\uFE0F Version: ".concat(_r)), _s && (c += "\n\t\uD83D\uDD17 See ".concat(_s, " for more details.")), i(e, c, a);
  }
}

export { s as deprecated, t as deprecatedFunction, o as deprecatedModule, r as deprecatedProperty };